import VueRouter from 'vue-router';
import store from './store';
import axios from 'axios';

import Login from './views/Login';
import Dashboard from './views/Dashboard';
import Profile from './views/Profile';
import MenuCreate from './views/MenuCreate';
import Spedizioni from './views/Spedizioni';
import SpedizioniMin from './views/SpedizioniMin';
import AggiungiPrenotazione from './views/AggiungiPrenotazione';
import VisualizzaPrenotazioni from './views/VisualizzaPrenotazioni';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from './views/ResetPassword';
import Referta from './views/Referta';
import StoricoPOD from './views/StoricoPOD';
import HandleCliente from './views/HandleCliente';
import HandleCorriere from './views/HandleCorriere';
import HandleVisualizzaPESATE from './views/HandleVisualizzaPESATE.vue';
import HandleStoricoPOD from './views/HandleStoricoPOD';
import HandleTrackingEvents from './views/HandleTrackingEvents';
import HandleMailNotifications from './views/HandleMailNotifications';
import HandleNotifications from './views/HandleNotifications';
import HandleFiliali from './views/HandleFiliali';
import Index2RifMit from './views/Index2RifMit';
import LocalitaDisagiate from './views/LocalitaDisagiate';
import Bollettazione from './views/Bollettazione';
import AdminBollettazione from './views/AdminBollettazione';


const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
  },
  {
    path: '/menucreate',
    name: 'menucreate',
    component: MenuCreate,
  },
  {
    path: '/spedizioni',
    name: 'spedizioni',
    component: Spedizioni,
  },
  {
    path: '/spedizioni-min',
    name: 'spedizioni-min',
    component: SpedizioniMin,
  },
  {
    path: '/referta',
    name: 'referta',
    component: Referta,
  },
  {
    path: '/aggiungiprenotazione',
    name: 'aggiungiprenotazione',
    component: AggiungiPrenotazione,
  },
  {
    path: '/visualizzaprenotazioni',
    name: 'visualizzaprenotazioni',
    component: VisualizzaPrenotazioni,
  },
  {
    path: '/storicopod',
    name: 'storicopod',
    component: StoricoPOD,
  },
  {
    path: '/localita-disagiate',
    name: 'localita-disagiate',
    component: LocalitaDisagiate,
  },
  {
    path: '/bollettazione',
    name: 'bollettazione',
    component: Bollettazione,
  },
  // Stesso componente, indirizzo diverso: serve alle due voci della tendina del menu
  // (sub_menu_items), che devono avere un link ciascuna. Vue riusa il componente fra
  // le due rotte, quindi passando da una scheda all'altra il modulo mezzo compilato
  // NON si perde. In piu' l'elenco diventa un indirizzo salvabile e che regge l'F5.
  {
    path: '/bollettazione/elenco',
    name: 'bollettazione-elenco',
    component: Bollettazione,
  },
  // 05/10/2026: spedizioni dei clienti viste da admin, sola lettura. La voce di menu
  // e' in menu_items con type = 'admin': il router apre solo le pagine del menu.
  {
    path: '/bollettazione-admin',
    name: 'bollettazione-admin',
    component: AdminBollettazione,
  },
  {
    path: '/clienti',
    name: 'clienti',
    component: HandleCliente,
  },
  {
    path: '/corrieri',
    name: 'corrieri',
    component: HandleCorriere,
  },
  {
    path: '/visualizzapesate-admin',
    name: 'visualizzapesate-admin',
    component: HandleVisualizzaPESATE,
  },
  {
    path: '/storicopod-admin',
    name: 'storicopod-admin',
    component: HandleStoricoPOD,
  },
  {
    path: '/tracking-events',
    name: 'tracking-events',
    component: HandleTrackingEvents,
  },
  {
    path: '/mail-notifications',
    name: 'mail-notifications',
    component: HandleMailNotifications,
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: HandleNotifications,
  },
  {
    path: '/filiali',
    name: 'filiali',
    component: HandleFiliali,
  },
  {
    path: '/index2.php',
    name: 'index2.php',
    component: Index2RifMit,
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: ForgotPassword,
  },
  {
    path: '/resetpassword/:token',
    name: 'resetpassword',
    component: ResetPassword,
  },
  {
    path: '/*',
    name: 'others',
    redirect: '/dashboard'
  }
];

const router = new VueRouter({
  history: true,
  mode: 'history',
  routes,
});

let whitelist = [
  '/login',
  '/forgotpassword',
];

let whitelistLogged = [
  '/profile',
  '/dashboard',
  //'/index2.php'
];

async function checkAndRedirect(to, next, status = -1) {
  let goNext = false;
  // 25/09/2026: il rinnovo si prova per TUTTI, non solo per chi ha spuntato
  // "ricordami" (deciso da Michele). Prima chi non l'aveva spuntato veniva buttato
  // al login appena cambiava videata, anche con il token ancora buono.
  if(status === 401)
    goNext = await (store.dispatch('refresh'));
  if (whitelist.includes(to.path) || to.path.startsWith('/resetpassword') || goNext) {
      next();
  } else {
      store.commit("logout");
      next({ name: "login" });
  }
}

router.beforeEach(async (to, from, next) => {
  try {
    store.commit('getUser');
    //await axios.get('/auth/test');
    const menuItemsData = (await axios.get('/menuitems')).data;
    const menuItems = menuItemsData.map(d => d.link);
    menuItemsData.forEach(m => m.sub_menu_items.forEach(s => menuItems.push(s.link)));
    if(whitelistLogged.includes(to.path) || menuItems.includes(to.path))
      next();
    else
      next({name: 'dashboard'});
  } catch(e) {
    await checkAndRedirect(to, next, e.response ? e.response.status : -1);
  }
});

export default router;
